export interface HierarchyLabel {
  cliente: string;
  local: string;
  conjunto: string;
  unidade: string;
  gerencia: string;
}

export const normalizeHierarchyLabel = (value: unknown): HierarchyLabel | null => {
  if (!value || typeof value !== 'object') return null;

  const labels = value as Partial<HierarchyLabel>;
  const requiredLabels: Array<keyof Pick<HierarchyLabel, 'cliente' | 'local' | 'conjunto' | 'unidade'>> = [
    'cliente',
    'local',
    'conjunto',
    'unidade',
  ];
  if (!requiredLabels.every((key) => typeof labels[key] === 'string')) return null;

  return {
    cliente: labels.cliente as string,
    local: labels.local as string,
    conjunto: labels.conjunto as string,
    unidade: labels.unidade as string,
    gerencia: typeof labels.gerencia === 'string' ? labels.gerencia : '',
  };
};
